import { AxiosRequestConfig } from 'axios';
import { IMedia } from '../../lib/MediasLib';
import addUploadCapabilities from '../../lib/addUploadCapabilities';
import { restApi } from '../../services/api';
import { AutoSaveMediaApi } from '../media/useMediaListManager';

export const brandPdfShowcaseRepository = (brandId: string | undefined): AutoSaveMediaApi => {
  const repository = {
    create: (data: IMedia, axiosConfig?: AxiosRequestConfig) =>
      restApi.post(`showroom/file-showcase`, data, axiosConfig),
    update: (data: IMedia, axiosConfig?: AxiosRequestConfig) =>
      restApi.patch(`showroom/file-showcase/${data.id}`, data, axiosConfig),
    remove: (data: IMedia) => restApi.delete(`showroom/file-showcase/${data.id}`),
    list: () => restApi.get(`showroom/${brandId}/file-showcase?limit=1000`),
  };

  addUploadCapabilities(repository);
  return repository;
};
